import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-communication-call1-icon',
  templateUrl: './communication-call1.component.html'
})
export class CommunicationCall1Component extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
